import React, { useState, useEffect } from 'react';
import { api_addBanner } from '../../../api/catering/banner';
import { api_getOffers } from '../../../api/offer';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const AddBanner = () => {
	const [loading, setLoading] = useState(false);
	const [image, setImage] = useState<File | null>(null);
	const navigate = useNavigate();

	useEffect(() => {
		// fetchOffers(); // Fetch offers on component mount
	}, []);


	const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files && event.target.files[0]) {
			setImage(event.target.files[0]);
		}
	};

	const addBanner = async () => {
		try {
			setLoading(true);
			if (!image) {
				toast.error('Please select an image');
				return;
			}
			const formData = new FormData();
			formData.append('image', image);

			const res = await api_addBanner(formData);
	 // Debugging: Check the response

			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message);
				setTimeout(() => {
					navigate('/catering/banner');
				}, 1000); // Navigate to banners list after 1 second
			} else {
				toast.error('Failed to add banner');
			}
		} catch (error) {
			console.error('Error adding banner:', error);
			toast.error('An error occurred while adding banner');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				flex: 1,
				padding: '40px',
			}}>
			<div className='mb-3'>
				<label htmlFor='image' className='form-label'>
					Banner Image
				</label>
				<input
					onChange={handleImageChange}
					style={{ width: '100%', maxWidth: '400px' }}
					className='form-control form-control-sm'
					id='image'
					type='file'
					accept='image/*'
				/>
			</div>
			<button
				onClick={addBanner}
				type='button'
				className='btn btn-lg btn-primary'
				disabled={loading || !image}>
				{loading ? 'Loading...' : 'Add Banner'}
			</button>
		</div>
	);
};

export default AddBanner;
